export default __webpack_public_path__ + "static/media/5.4acc62bd.jpg";